import apiEstagio from "./api";

export const EstagioService = {
  getAll:()  => {
    return apiEstagio.get("/portal/estagio/allSemAnexos").then(data => {
      // console.log("SERVICE", data);
      return data;
    });
  },
  
  findByCurso: (curso) => {
    return apiEstagio.get("/portal/estagio/findByCurso?curso=" + curso);
  },

  getAllCursos:() =>{
    return apiEstagio.get("/portal/estagio/allCursos")
  },

  findByCpf:(cpf) =>{
    return apiEstagio.get("portal/estagio/findByCpf?cpf="+cpf)
  },

  allInstituicoes:() =>{
    return apiEstagio.get("portal/estagio/allInstituicoes")
  },

  inscricao:(body) =>{
    return apiEstagio.post("/portal/estagio/inscricao",body)
  },
  alteraInscricao:(estagioId,body) =>{
    return apiEstagio.put("/portal/estagio/update?estagioId="+estagioId,body)
  },
  getBySituacao:(situacao) =>{
    return apiEstagio.get("/portal/estagio/getSituacao?situacao="+situacao)
  }
}
